export default __webpack_public_path__ + "static/media/backgroundCenter.b4817fb6.png";